<script>
    // import {flow_info, flow_stack} from './stores.js';
    import{flow_steps, user_data} from './stores.js';
    import { onMount } from "svelte";
    import Iqtemplate from "./components/iqtemplate.svelte";
    import Progresscomponent from "./components/progresscomponent.svelte";
    import Chipscompnent from './components/chipscompnent.svelte';

    export let chipsdata = [
        {s: true, t: "Purchase", i:"/img/House.svg", cbf:()=>{$flow_steps.current_flow = "iqp"; $user_data.loantype = "Purchase"; $flow_steps.current_next_loc = 2; $flow_steps.current_prev_loc = 0;}},
        {s: false, t: "Refinance", i:"/img/Refinance.svg", cbf:()=>{$flow_steps.current_flow = "iqr"; $user_data.loantype = "Refinance"; $flow_steps.current_next_loc = 2; $flow_steps.current_prev_loc = 0;}},
    ];

    // onMount(async() => {

    // });

</script>

<Iqtemplate
progress_mobile_version={true}
>
    <Progresscomponent 
    title="What type of rates are you looking for?"
    show_next_button={false}
    >
    <Chipscompnent
        bind:chipsdata={chipsdata}
    />
    </Progresscomponent>
</Iqtemplate>

<style>

</style>